import ROUTES from "@/data/Routes";
import {
  HomeHeroVariant,
  isValidHomeHeroVariant,
} from "@/data/homeHeroVariants";

const HOME_HERO_SESSION_KEY = "telomera_home_hero";

export const getHomeHeroSession = (): HomeHeroVariant | null => {
  try {
    const value = sessionStorage.getItem(HOME_HERO_SESSION_KEY);
    return isValidHomeHeroVariant(value) ? value : null;
  } catch {
    return null;
  }
};

export const setHomeHeroSession = (hero: HomeHeroVariant): void => {
  try {
    sessionStorage.setItem(HOME_HERO_SESSION_KEY, hero);
  } catch {
    // ignore storage errors
  }
};

export const getHomeHref = (search = ""): string => {
  const heroFromUrl = new URLSearchParams(search).get("hero");
  if (isValidHomeHeroVariant(heroFromUrl)) {
    return `${ROUTES.HOME}?hero=${heroFromUrl}`;
  }

  const savedHero = getHomeHeroSession();
  if (savedHero) {
    return `${ROUTES.HOME}?hero=${savedHero}`;
  }

  return ROUTES.HOME;
};

export const resolveHomeHeroQuery = (
  heroFromUrl: string | null | undefined,
): string => {
  if (isValidHomeHeroVariant(heroFromUrl)) {
    return heroFromUrl;
  }

  return getHomeHeroSession() ?? "";
};
